<template>
	<div class="address_big">
		<div style="width:1260px;margin:0 auto;padding-bottom:30px;">
			<div class="address_top">
				<div class="title">收货地址</div>
				<div class="address_text">
					<div class="left">
						<div>
							<div style="">
								<span style="color:#909199;letter-spacing:4px">收货人：</span>
								<span v-if="orderdetail">{{orderdetail.addressJson.consignee}}</span>
							</div>
							<div style="margin:20px 0">
								<span style="color:#909199">联系方式：</span>
								<span v-if="orderdetail">{{orderdetail.addressJson.mobile}}</span>
							</div>
							<div>
								<span style="color:#909199">收货地址：</span>
								<span v-if="orderdetail">{{orderdetail.addressJson.province}}{{orderdetail.addressJson.city}}{{orderdetail.addressJson.district}}{{orderdetail.addressJson.town?orderdetail.addressJson.town:''}}{{orderdetail.addressJson.detail}}</span>
							</div>
						</div>
						
					</div>
				</div>
			</div>
			<div class="address_bottom">
				<p style="font-size:18px;color:#0A1132;margin-bottom:10px">{{ordername}}</p>
				<div class="lists" v-for="itemb in orderdetail.subOrders" :key="itemb.id">
					<div class="list_top">
						<span style="width:600px;font-size:16px;">{{itemb.externalOrderId}}</span>
						<span class="rights" style="font-size:16px;">数量</span>
						<span class="rights" style="font-size:16px;">状态</span>
						<span style="cursor: pointer;color:#3395F5;font-size:16px;" class="rights" @click='binddzm(itemb)' v-if="itemb.virtualCodeJson && itemb.virtualCodeJson.length > 0">查看电子码</span>
						<span style="cursor: pointer;color:#3395F5;font-size:16px;" class="rights" @click='bindwl(itemb.uid)' v-if="itemb.virtualCodeJson.length === 0 && itemb.shippingStatus!=0">查看物流</span>
						
					</div>
					<div class="list_bottom">
						<!-- <div v-for="items in orderdetail.orderItems" :key="items.id"> -->
							<div class="l_box" v-for="(item,index) in itemb.s_list" :key="item.id">
								<div style="display: flex;align-items: center;width:600px;">
									<img style="height:80px;width:80px;margin-right:16px" :src="item.itemSkuJson.baseImage"/>
									
									<div>
										<p>{{item.itemSkuJson.itemAttrValue}}</p>
										<div style="color:#909199" v-for="(item2, index3) in item.attrJson" :key="item2.attrId">{{item2.name}}：{{item2.optionValue}}</div>
										<div style="color:#909199" v-for="(item2, index3) in item.subGoodsJson" :key="index3">
											{{item2.name}}：{{item2.sub_name}}
										</div>
										<p style="margin-top:5px;color:#909199" v-if="item.cakeTime">配送时间：{{item.cakeTime}}</p>
										<p style="margin-top:5px;color:#909199" v-if="item.expectShippingDate">期望发货日期：{{item.expectShippingDate}}</p>
									</div>
									
									
								</div>
								<span class="rights">{{item.purchaseNumber}}</span>
								<!-- <span class="rights">待发货</span> -->
								<div class="rights">
									<span  style="font-size:28rpx;color:#FF5C4D;height:24px" v-if="(orderdetail.status==2||orderdetail.status==3||orderdetail.status==5)&&item.orderStatus==1">{{shippingStatus[item.shippingStatus]}}</span>
                                	<span style="font-size:28rpx;color:#FF5C4D;height:24px" v-if="(orderdetail.status==0||orderdetail.status==2||orderdetail.status==3||orderdetail.status==5)&&item.orderStatus!=1">{{orderStatus[item.orderStatus]}}</span>
								</div>
								
								<div class="rights ">
									<!-- <span class="ckwl" @click='bindwl(item.uuid)'>查看物流</span> -->
									<!-- <span class="ckwl" @click='bindwl(item.uuid,index)' v-if="item.shippingStatus!=0">查看物流</span> -->
								</div>
							</div>
						<!-- </div> -->
						
						
					</div>
				</div>
			</div>
			<div class="address_top" style="height:auto" v-if="user&&user.festival.type==2&&user.festival.id!=$store.state.hidePriceid">
				<div class="title">
					支付明细
					<div class="fy_box">
						<div>
							<span style="color:#909199">礼包价格：</span>
							<img style="width:16px;height:16px;background:none;margin-left: 20px;" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
							<img style="width:16px;height:16px;" v-if="!user.festival.priceSymbol||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
							<span style="font-size:14px;color:#0A1132; ">{{orderdetail.salePrice/100}}</span>
							<span style="font-size:14px;color:#0A1132;" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
						</div>
						<div style="margin:0 40px;">
							<span style="color:#909199">运费：</span>
							<img style="width:16px;height:16px;background:none;margin-left: 20px;" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
							<img style="width:16px;height:16px;" v-if="!user.festival.priceSymbol||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
							<span style="font-size:14px;color:#0A1132; ">{{orderdetail.freightPrice/100}}</span>
							<span style="font-size:14px;color:#0A1132;" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
						</div>
						<div style="margin-right:11px;">
							<span style="color:#909199">实付款：</span>
							<img style="width:16px;height:16px;background:none;margin-left: 20px;" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
							<img style="width:16px;height:16px;" v-if="!user.festival.priceSymbol||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
							<span style="font-size:16px;color:#FD5430;font-weight:600">{{orderdetail.totalPrice/100}}</span>
							<span style="font-size:16px;color:#FD5430;font-weight:600" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
						</div>
					</div>
				</div>
				<div class="address_text" style="">
					<div class="left zf_left" style="width:100%">
						<div class='zf_box' v-for="(item,index) in orderdetail.orderPays" :key='index' v-if="item.payStatus!='CREATED'&&item.payStatus!='CANCEL'">
							<div style="">
								<span style="color:#0A1132;font-size:16px;">{{item.payType=='CARD'?item.ticketCardNo:'微信支付'}}</span>
							</div>
							<div style="margin:6px 0" class="sale_price">
								<div>
									<span style="color:#909199">支付金额：</span>
									<img style="width:16px;height:16px;background:none;margin-left: 20px;" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)=='http'" :src="user.festival.priceSymbol" />
									<img style="width:16px;height:16px;background:white" v-if="!user.festival.priceSymbol||!user.festival.priceSymbol" src="../../assets/img/pindou.png" />
									<span style="font-size:16px;color:#FD5430;font-weight:600">{{item.payAmount/100}}</span>
									<span style="font-size:16px;color:#FD5430;font-weight:600" v-if="user.festival.priceSymbol&&user.festival.priceSymbol.slice(0,4)!='http'">{{user.festival.priceSymbol}}</span>
								</div>
								<div>
									<span style="color: #23CC5E;" v-if="item.payStatus=='SUCCESS'&&item.refundStatus=='NONE'">支付成功</span>
									<span style="color: rgb(253, 84, 48);" v-if="item.payStatus=='PAYING'">支付中</span>
									<span style="color: rgb(253, 84, 48);" v-if="item.refundStatus=='REFUNDING'">退款中</span>
									<span style="color: rgb(253, 84, 48);" v-if="item.refundStatus=='REFUNDED'">已退款</span>
									<span style="color: rgb(253, 84, 48);" v-if="item.refundStatus=='REFUNDFAIL'">退款失败</span>
									<span style="color: #23CC5E;" v-if="item.payStatus=='EXPIRED'||item.payStatus=='CANCEL'">{{item.opBy}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="address_top" style="height:auto;">
				<div class="title">订单信息</div>
				<div class="address_text">
					<div class="left" style="width:100%">
						<div>
							
							
							<div style="">
								<span style="color:#909199;letter-spacing:4px">订单号：</span>
								<span style="color:#909199;" v-if="orderdetail">{{orderdetail.externalOrderId}}</span>
							</div>
							<div style="margin:20px 0">
								<span style="color:#909199">下单时间：</span>
								<span style="color:#909199;" v-if="orderdetail">{{orderdetail.createAt}}</span>
							</div>
							<!-- <div>
								<span style="color:#909199">交易时间：</span>
								<span style="color:#909199;" v-if="orderdetail">{{orderdetail.opAt}}</span>
							</div> -->
							<div style="margin-top:20px;" v-if="orderdetail.internalOrderJson&&orderdetail.internalOrderJson.remark.length>0">
								<span style="color:#909199;">订单备注：</span>
								<span style="color:#909199;" v-if="orderdetail">{{orderdetail.internalOrderJson.remark[0].remark}}</span>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title="物流"
		  :visible.sync="tpVisible"
		  width="620px"
		  center>
		  <div style="padding:0 25px;">
			  <div style="margin-bottom:10px;">
			  <span style="margin-right:20px;padding-bottom:5px;cursor: pointer;" @click="bindwlnav(index)" :class="w_index==index?'active':''" v-for="(item,index) in wl_list" :key='index'>包裹{{index+1}}</span>
		  	</div>
			  <div style="display:flex;justify-content: space-between;align-items: center;">
				  	<div v-if="wl_list[w_index]" style="margin:10px;margin-bottom:10px;margin-left:0;color:#0A1132">物流公司：{{wl_status[wl_list[w_index].shipperCode]}}</div>
		  			<div v-if="wl_list[w_index]" style="margin:10px;margin-bottom:10px;margin-left:0;color:#0A1132">物流单号：{{wl_list[w_index].logisticCode}}</div>
			  </div>
		  	 <div v-if="wl_list[w_index]" style="display:flex;margin-bottom:10px;">
				<div style="color:#0A1132">商品名称：</div>
				<div style="color:#0A1132">
					<div v-for="(itemp,iindex) in wl_list[w_index].skus" :key='iindex' v-if="iindex<iindex_show" style=";margin-bottom:4px;display:flex;justify-content: space-between;align-items: center;width:490px">
						<span>{{sp_list[itemp.skuId]}}</span>
						<span>x {{itemp.count}}</span>
					</div>
					<div style="color:#3395F5;cursor: pointer;" v-if="wl_list[w_index].skus.length>3&&iindex_show!=20" @click="iindex_show=20">查看更多</div>
					<div style="color:#3395F5;cursor: pointer;" v-if="wl_list[w_index].skus.length>3&&iindex_show==20" @click="iindex_show=3">收起</div>
				</div>
			</div>
		  </div>
		  	
			<div v-if="wl_list[w_index]" style="padding:30px 25px;background:#F5F5F5;height:350px;max-height:550px;overflow: auto;">
				<div v-if="wl_list[w_index].traces.length>0">
					<div  class="wl_box" v-for="(item1,index1) in wl_list[w_index].traces" :key='index1'>
							<div class="yuan"></div>
							<span>{{item1.acceptTime}}</span>
							<p style="width:360px;">{{item1.acceptStation}}</p>
					</div>
				</div>
				<div v-else>
						<span>{{wl_list[w_index].msg}}</span>
				</div>
			</div>

		 <div slot="footer"  class="dialog-footer" style="text-align: center;">
		    <el-button style="height：42px;width:144px;background:#F3A251;color:white;" @click="tpVisible = false">确定</el-button>
		    <el-button style="height：42px;width:144px;" @click="tpVisible = false">取消</el-button>
		  </div>	
		</el-dialog>

		<el-dialog
		  title="查看二维码"
		  :visible.sync="dzm_show"
		  width="620px"
		  center>
		  <div>
			  <div style="display:flex;padding:0 24px;margin-bottom:30px;" v-if="name_data">
				  <img style="height:80px;width:80px;background:#F5F5F5;margin-right:10px" :src="name_data.s_list[0].itemSkuJson.baseImage" alt="">
				  <div style="margin-top:10px;">
					   <p>{{name_data.s_list[0].itemSkuJson.itemAttrValue}}</p>
					   <p>数量：{{txt_data.length}}</p>
					</div>
			  </div>
			  <div style="max-height:500px;overflow:auto">
				  <div v-for="(item,index) in txt_data" :key='index'>
					<div class="txt_box" v-if="item.barType==0&&item.pwd_show">
						<div style="color:#0A1132;line-height:24px;">
							<p>劵号：{{item.codeSrc}}</p>
							<p>使用期至：{{item.endTime}}</p>
						</div>
							<p style="color:#0A1132;margin-top:10px;">使用步骤：点击下面链接打开，查看二维码。</p>
							<div style="color:#0A1132">
								链接：
								<a :href="item.pwdSrc" style="color:#2d8cf0!important" target="_blank">{{item.pwdSrc}}</a>
							</div>
					</div>
					<div class="txt_box" v-else>
						<div style="color:#0A1132;line-height:24px;">
							<p>劵号：{{item.codeSrc}}</p>
							<p>密码：{{item.pwdSrc}}</p>
							<p>使用期至：{{item.endTime}}</p>
						</div>
							<useCodeGenerate v-if='item.barType!=0' :code="item.pwdSrc" :code-type="item.barType===1?'qrCode':'barCode'" :size="200"></useCodeGenerate>
					</div>
					
				</div>
			  </div>
			  
			  
		  </div>

		 <div slot="footer"  class="dialog-footer" style="text-align: center;">
		    <el-button style="height：42px;width:144px;background:#F3A251;color:white;" @click="dzm_show = false">确定</el-button>
		    <el-button style="height：42px;width:144px;" @click="dzm_show = false">取消</el-button>
		  </div>	
		</el-dialog>
	</div>


</template>

<script>
import nav from '../nav'
import getCurrentCityName from '../../js/map'
import links from '../../js/link_parameters'
import wechatAuth from '../../wechatAuth'
import { Message, Loading } from 'element-ui'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Vue from 'vue'
import $ from 'jquery'
import axios from 'axios'
import Tables from '../../components/tables/tables'
import useCodeGenerate from '../../components/useCodeGenerate'
import echarts from 'echarts'
import { formatDate, formatTimeToStr } from '../../js/data'
// import JsBarcode from 'jsbarcode'
export default {
  name: 'index',
  components: {
    Tables,
    useCodeGenerate
  },
  data() {
    var vm = this
    return {
      iindex_show: 3,
      status_list: {
        0: '等待付款',
        1: '下单失败',
        2: '下单部分失败',
        3: '已付款',
        4: '订单失效',
        5: '已完成'
      },
      shippingStatus: {
        0: '待发货',
        1: '已发货',
        2: '已收货',
        3: '备货中',
        4: '已发货(部分商品)',
        5: '发货中(处理分单)',
        6: '已发货(部分商品)'
      },
      orderStatus: {
        0: '商家确认中',
        2: '已取消',
        3: '下单失败',
        4: '申请退货',
        5: '部分退货',
        6: '全部退货'
      },
      wl_status: {
        SF: '顺丰',
        HTKY: '百世快递',
        ZTO: '中通',
        STO: '申通',
        YTO: '圆通',
        YD: '韵达',
        YZPY: '邮政平邮',
        EMS: 'EMS',
        HHTT: '天天',
        JD: '京东',
        QFKD: '全峰',
        GTO: '国通',
        UC: '优速',
        DBL: '德邦',
        FAST: '快捷',
        AMAZON: '亚马逊',
        ZJS: '宅急送',
        ANE: '安能物流',
        ANEKY: '安能快运',
        PJ: '品骏',
        TNT: 'TNT快递',
        UPS: 'UPS',
        DHL: 'DHL',
        FEDEX: 'FEDEX联邦(国内件)',
        FEDEX_GJ: 'FEDEX联邦(国际件)'
      },
      datas: {},
      add_show: false,
      mr_checked: false,
      orderid: this.$route.query.id ? this.$route.query.id : '',
      ordername: this.$route.query.name ? this.$route.query.name : '',
      tpVisible: false,
      orderdetail: '',
      w_index: 0,
      wl_list: [],
      sp_list: {},
      dzm_show: false,
      txt_data: '',
      name_data: '',
      user: ''
    }
  },
  computed: {},
  created() {},
  mounted() {
    var user = sessionStorage.getItem('user')

    if (user) {
      this.user = JSON.parse(user)
    } else {
      this.$router.push({ path: '/login' })
    }
    this.bindorder_detail()
    if (!this.$store.state.balance) {
      this.getUser()
    }
    console.log(axios.defaults.baseURL)
  },
  methods: {
    getUser() {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.getCardUserBalance({}, headers).then((res) => {
        console.log('', res)
        if (res.code == 0) {
          var user = this.user
          this.$store.state.cardDate = res.data.default.cardDate
          this.$store.state.validTimes = res.data.default.validTimes
          this.$store.state.balance = res.data.default.balance
          sessionStorage.setItem('user', JSON.stringify(user))
        }
      })
    },
    CheckUrl(str) {
      var lv = str.slice(0, 4)
      return lv
    },
    binddzm(e) {
      this.dzm_show = true
      var data = typeof e.virtualCodeJson == 'string' ? JSON.parse(e.virtualCodeJson) : e.virtualCodeJson
      console.log(data)
      data.forEach((item) => {
        console.log(item)
        item.endTime = formatTimeToStr(Number(item.endTime) * 1000, 'yyyy-MM-dd')
        item.pwd_show = this.CheckUrl(item.pwdSrc) == 'http' ? true : false
      })
      this.txt_data = data
      this.name_data = e
      // this.bindscm()
      console.log(e)
    },
    bindscm() {
      var data = this.txt_data
      data.forEach((item, index) => {
        var id = 'canvas' + index
        // if (item.barType == 0) {
        // 	wxbarcode.barcode(id, item.url, 680, 150);
        // }
        // if (item.barType == 1) {
        // 	wxbarcode.qrcode(id, item.url, 300, 300);
        // }
        // let barCode = "12345678"
        // JsBarcode(id, item.url,{
        // format: "CODE128",//选择要使用的条形码类型
        // text: barCode,    //显示文本
        // displayValue: true,//是否在条形码下方显示文字
        // textPosition: "bottom",//设置文本的垂直位置
        // fontOptions:"bold italic",//使文字加粗体或变斜体
        // background:"#eee",//设置条形码的背景
        // font:"fantasy",//设置文本的字体
        // lineColor:"#2196f3",//设置条和文本的颜色。
        // margin:15//设置条形码周围的空白边距
        // })
      })
    },
    bindwlnav(e) {
      this.w_index = e
    },
    bindwl(e, a) {
      console.log(e)
      var data = {
        subOrderUid: e
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.queryItemOrderExpress(data, headers).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.tpVisible = true
          var list = res.data.default
          list.forEach((item) => {
            item.traces = item.traces ? item.traces.reverse() : []
          })
          this.wl_list = list
          this.bindpp(list)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    bindpp(list) {
      console.log(this.sp_list)
      console.log(this.orderdetail)
      list.forEach((items) => {
        this.orderdetail.subOrders.forEach((item) => {
          console.log(typeof item.expressJson)
          if (item.expressJson && typeof item.expressJson == 'string') {
            item.expressJson = item.expressJson ? JSON.parse(item.expressJson) : []
          }

          item.expressJson.forEach((item1) => {
            console.log(items.logisticCode, item1.express_sn)
            item1.express_sn = item1.express_sn.trim()
            if (items.logisticCode == item1.express_sn) {
              items.skus = item1.skus ? item1.skus : ''
            }
          })
        })
      })
      console.log(list)
    },
    bindduihuang() {
      this.$router.push({ path: '/result' })
    },
    bindorder_detail() {
      var data = {
        parentOrderUid: this.orderid
      }
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: this.user.token
      }
      this.$server.getItemOrder(data, headers).then((res) => {
        console.log(res)
        var list = res.data.default
        list.addressJson = list.addressJson ? JSON.parse(list.addressJson) : ''
        list.externalOrderJson = list.externalOrderJson ? JSON.parse(list.externalOrderJson) : ''
        list.internalOrderJson = list.internalOrderJson ? JSON.parse(list.internalOrderJson) : ''
        var sp_list = {}
        list.orderItems.forEach((item, index) => {
          if (list.externalOrderJson.childOrders) {
            list.externalOrderJson.childOrders.forEach((itemf) => {
              itemf.sku.forEach((itemg) => {
                if (itemg.skuId == item.skuId) {
                  item.cakeTime = itemg.cakeTime
                }
              })
            })
          }
        })
        list.subOrders.forEach((items) => {
          items.s_list = []
          list.orderItems.forEach((item, index) => {
            sp_list[item.skuId] = item.skuName
            console.log(sp_list)
            // var ddd={item.skuId=item.skuName}
            if (item.skuId == 0) {
              list.orderItems.splice(index, 1)
              return
            }

            console.log(typeof item.itemSkuJson == 'string')
            item.itemSkuJson = typeof item.itemSkuJson == 'string' ? JSON.parse(item.itemSkuJson) : item.itemSkuJson
            item.attrJson = typeof item.attrJson == 'string' ? JSON.parse(item.attrJson) : item.attrJson
            item.subGoodsJson = typeof item.subGoodsJson == 'string' ? JSON.parse(item.subGoodsJson) : item.subGoodsJson
            console.log(item)

            if (item.subOrderId == items.id) {
              item.orderStatus = items.orderStatus
              item.uuid = items.uid
              item.shippingStatus = items.shippingStatus
              items.s_list.push(item)
            }
          })
          let virtualCodeJson = []
          if (items.virtualCodeJson) {
            virtualCodeJson = JSON.parse(items.virtualCodeJson)
          }
          items.virtualCodeJson = virtualCodeJson
        })
        console.log(list)
        this.sp_list = sp_list
        this.orderdetail = list
      })
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
.sale_price {
  display: flex;
  justify-content: space-between;
}
.zf_left {
  display: flex;
  flex-wrap: wrap;
}
.zf_box:nth-child(4n + 4) {
  margin-right: 0;
}
.zf_box {
  width: 294px;
  height: 114px;
  border: 1px solid #e6e6e6;
  padding: 16px 20px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.txt_box {
  background: #f5f5f5;
  padding: 16px 24px;
  margin-bottom: 20px;
}
.active {
  color: #f3a251;
  border-bottom: 1px solid #f3a251;
}
.wl_box:last-child {
  border: none !important;
  .yuan {
    left: -2px;
  }
}
.wl_box:nth-child(1) {
  .yuan {
    height: 13px !important;
    width: 13px !important;
    background: #f3a251;
    top: -14px;
    left: -6px;
  }
  p {
    color: #0a1132 !important;
  }
  span {
    color: #0a1132 !important;
  }
}
.wl_box {
  display: flex;
  padding-left: 20px;
  margin-bottom: 12px;
  border-left: 1px solid #cccccc;
  position: relative;
  .yuan {
    position: absolute;
    top: -8px;
    left: -3px;
    height: 5px;
    border-radius: 50%;
    width: 5px;
    background: #cccccc;
  }
  span {
    width: 160px;
    display: inline-block;
    margin-right: 13px;
    color: #5b5d66;
    position: relative;
    top: -14px;
  }
  p {
    color: #5b5d66;
    position: relative;
    top: -14px;
  }
}
.ckwl {
  width: 100px;
  height: 34px;
  border: 1px solid #e6e6e6;
  color: #0a1132;
  font-size: 16px;
  cursor: pointer;
  line-height: 34px;
  text-align: center;
  display: inline-block;
}
.dz_top_active {
  border-color: #f3a251 !important;
  background: url('../../assets/img/dz_xz.png') no-repeat right bottom;
}
.dz_box {
  height: 87px;
  cursor: pointer;

  border: 1px solid #e6e6e6;
  padding: 14px 16px;

  margin-bottom: 16px;
  .dz_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.add_rights {
  padding-left: 12px;
  display: flex;
  flex-direction: column;
}
.new_adds {
  width: 144px;
  height: 42px;
  display: inline-block;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
}
.new_add {
  width: 144px;
  height: 42px;
  border: 1px solid rgba(232, 232, 232, 1);
  display: inline-block;
  text-align: center;
  line-height: 42px;
  cursor: pointer;
}
.address_bottom {
  margin-top: 30px;
}
.lists {
  min-height: 50px;
  border: 1px solid #e6e6e6;
  .rights {
    width: 200px;
    text-align: center;
  }
  .list_bottom {
    min-height: 200px;
    padding: 0 24px;
    .l_box:last-child {
      border: none;
    }
    .l_box {
      display: flex;
      align-items: center;
      padding: 24px 0;
      border-bottom: 1px dotted #cccccc;
    }
  }
  .list_top {
    display: flex;
    color: #909199;
    background: #f5f5f5;
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
  }
}
.select {
  width: 145px;
  height: 32px;
  margin-right: 24px;
}
.address_text {
  // height:247px;
  width: 100%;
  padding: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    width: 421px;
    height: 100%;
    border-left: 1px dotted #cccccc;
    padding-left: 32px;
    .aniu {
      display: flex;
      align-items: center;
    }
    .ljdhs {
      height: 50px;
      width: 186px;
      display: inline-block;
      line-height: 50px;
      margin-left: 10px;
      cursor: pointer;
      text-align: center;
      color: #f3a251;
      border: 1px solid;
      background: #fffaf6;
    }
    .ljdh {
      height: 50px;
      cursor: pointer;
      width: 186px;
      background: #f3a251;
      display: inline-block;
      line-height: 50px;
      text-align: center;
      color: white;
    }
  }
  .left {
    height: 100%;
    width: 738px;
    .boxx11 {
      display: flex;
      justify-content: space-between;
    }
    .boxx {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      .boxx1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 47%;
      }
    }
  }
}
.address_top {
  border: 1px solid #e6e6e6;
  margin-top: 32px;
  height: 185px;
  width: 100%;
  .title {
    height: 44px;
    width: 100%;
    background: #f5f5f5;
    color: #909199;
    font-size: 16px;
    line-height: 44px;
    padding-left: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .fy_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
.address_big {
  min-height: 87vh;
  border-top: 1px solid #e4e5ed;
}
</style>
